import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { PhasesSection } from '../components/PhasesSection';
import { AgendaSection } from '../components/AgendaSection';
import { RouteMapSection } from '../components/RouteMapSection';
import { VenueMapSection } from '../components/VenueMapSection';
import { PetWallSection } from '../components/PetWallSection';
import { TicketsSection } from '../components/TicketsSection';
import { SponsorsSection } from '../components/SponsorsSection';
import { ActivitiesSection } from '../components/ActivitiesSection';
import { LocationSection } from '../components/LocationSection';
import { CauseSection } from '../components/CauseSection';
import { ContactSection } from '../components/ContactSection';
import { SponsorsBannerSection } from '../components/SponsorsBannerSection';
export function HomePage() {
  return <>
      <HeroSection data-id="element-2196" />
      <ActivitiesSection data-id="element-2197" />
      <AboutSection data-id="element-2198" />
      <TicketsSection data-id="element-2199" />
      <CauseSection data-id="element-2200" />
      <SponsorsBannerSection data-id="element-2201" />
      <SponsorsSection data-id="element-2202" />
      <AgendaSection data-id="element-2203" />
      <RouteMapSection data-id="element-2204" />
      <VenueMapSection data-id="element-2205" />
      <PetWallSection data-id="element-2206" />
      <LocationSection data-id="element-2207" />
      <PhasesSection data-id="element-2208" />
      <ContactSection data-id="element-2209" />
    </>;
}